import { render, staticRenderFns } from "./MoNotFoundPage.vue?vue&type=template&id=16ee359a&scoped=true&"
var script = {}
import style0 from "./MoNotFoundPage.vue?vue&type=style&index=0&id=16ee359a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ee359a",
  null
  
)

export default component.exports